
import { Product } from "@/types/product";
import { vpxTC1LT } from "./vpx-tc1-lt";
import { vpxTC1PRO } from "./vpx-tc1-pro";
import { vpxTC1UCP } from "./vpx-tc1-ucp";
import { vpxTC1WP2 } from "./vpx-tc1-wp-2";
import { vpxUC1ULTRA } from "./vpx-uc1-ultra";
import { vpxRX1PROSDM } from "./vpx-rx1-pro-sdm";

export const vpxProducts: Product[] = [
  vpxTC1LT,
  vpxTC1PRO,
  vpxTC1UCP,
  vpxTC1WP2,
  vpxUC1ULTRA,
  vpxRX1PROSDM
];
